import { RootState } from "../../store";

export const userdataReducer = (state:UserData | {}, action:any) => {
    switch (action.type) {
        case 'SET_USERDATA':
            state = action.payload;
            return state;
        default:
            return state || {};
    }
}

export const usersReducer = (state:Users | {}, action:any) => {
    switch (action.type) {
        case 'SET_USERS':
            state = action.payload;
            return state;
        default:
            return state || {};
    }
}

export const colleaguesReducer = (state:ForwardUser[] | [], action:any) => {
    switch (action.type) {
        case 'SET_COLLEAGUES':
            state = action.payload;
            return state;
        default:
            return state || []
    }
}